export const SHOP_IDS = {
  RAGTAG: 'TPNJQT6BXAcwCrXC4nTmu9',
  MANDARAKE: 'd2uUKgmbjTGT7BzBGUnXxe',
} as const;
export type ShopId = (typeof SHOP_IDS)[keyof typeof SHOP_IDS];

export interface ShopInfo {
  id: ShopId;
  sellerName: string;
  shopNameKor: string;
  shortDesc: string;
}

export const SHOPS: Record<ShopId, ShopInfo> = {
  [SHOP_IDS.RAGTAG]: {
    id: SHOP_IDS.RAGTAG,
    sellerName: '래그태그(ragTag)',
    shopNameKor: '래그태그',
    shortDesc: '빈티지/셀렉트 샵',
  },
  [SHOP_IDS.MANDARAKE]: {
    id: SHOP_IDS.MANDARAKE,
    sellerName: '만다라케(mandarake)',
    shopNameKor: '만다라케',
    shortDesc: '최대 서브컬쳐 샵',
  },
} as const;

// 기존 AUTHORIZED_SHOPS는 SHOP_IDS를 사용하도록 수정
export const AUTHORIZED_SHOPS = {
  ragTag: { id: SHOP_IDS.RAGTAG },
  mandarake: { id: SHOP_IDS.MANDARAKE },
} as const;

export const VALID_SHOP_IDS = Object.values(AUTHORIZED_SHOPS).map((shop) => shop.id);
